var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"volunteer-home-intro-content"},[_c('div',{staticClass:"article__html",domProps:{"innerHTML":_vm._s(_vm.curData_.txt)}})])}
var staticRenderFns = []

export { render, staticRenderFns }